import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { Loader2 } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";

const isDisabledDay = (d) => d < new Date(new Date().setHours(0, 0, 0, 0)) || d.getDay() === 0 || d.getDay() === 6;

export const SlotStep = ({ date, onDateChange, slots, slotsLoading, selectedSlot, onSelectSlot }) => (
  <div className="grid gap-8 rounded-2xl border border-[#2C2A29]/10 bg-white p-6 sm:grid-cols-2 sm:p-8" data-testid="booking-slot-picker">
    <div>
      <p className="mb-3 text-sm font-semibold text-argia-ink">Choisissez une date</p>
      <Calendar
        mode="single"
        selected={date}
        onSelect={onDateChange}
        locale={fr}
        disabled={isDisabledDay}
        className="rounded-xl border border-[#2C2A29]/10"
        data-testid="booking-calendar"
      />
    </div>
    <div>
      <p className="mb-3 text-sm font-semibold text-argia-ink">
        {date ? `Créneaux du ${format(date, "EEEE d MMMM", { locale: fr })}` : "Sélectionnez d'abord une date"}
      </p>
      {slotsLoading && (
        <div className="flex items-center gap-2 text-sm text-argia-muted" data-testid="slots-loading">
          <Loader2 size={16} className="animate-spin" /> Recherche des disponibilités…
        </div>
      )}
      {!slotsLoading && date && slots.length === 0 && (
        <p className="text-sm text-argia-muted" data-testid="slots-empty">Aucun créneau disponible ce jour-là. Essayez une autre date.</p>
      )}
      <div className="grid grid-cols-3 gap-2.5">
        {slots.map((s) => (
          <button
            key={s.start}
            data-testid={`slot-${s.label.replace(":", "")}`}
            onClick={() => onSelectSlot(s.start)}
            className={`rounded-lg border px-3 py-2.5 text-sm font-semibold transition-all duration-200 ${
              selectedSlot === s.start ? "border-argia-red bg-argia-red text-white" : "border-[#2C2A29]/15 text-argia-ink hover:border-argia-red/50"
            }`}
          >
            {s.label}
          </button>
        ))}
      </div>
    </div>
  </div>
);
